// src/pages/Ads/components/DetailPolicy.jsx
import React from "react";
// import PrivacyPolicyFull from "./PrivacyPolicyFull";
import TermsofServiceFull from "./TermsofServiceFull";
import PrivacyPolicyFull20251202 from "../../../../pages/policy/Components/PolicyVersion/PrivacyPolicyFull20251202"



export default function DetailPolicy({ type = "tos" }) {
  if (type === "privacy") return <PrivacyPolicyFull20251202 />;
  if (type === "tos") return <TermsofServiceFull />;

  return (
    <div className="text-sm text-gray-500">
      Unknown policy type: <b>{String(type)}</b>
    </div>
  );
}
